module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }